import { useNavigate } from 'react-router-dom';
import { Building2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function NoAgencyBanner() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center px-6">
      <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mb-5">
        <Building2 className="w-6 h-6 text-primary" />
      </div>
      <h2 className="text-xl font-semibold tracking-tight mb-2">Primero crea tu agencia</h2>
      <p className="text-sm text-muted-foreground max-w-sm mb-6">
        Para gestionar propiedades, clientes y leads necesitas una agencia. Solo toma un momento.
      </p>
      <Button onClick={() => navigate('/admin/agency')}>
        Crear agencia
      </Button>
    </div>
  );
}
